import React, { useRef, useState, useEffect } from 'react';
import { InputGroup, FormControl, Spinner } from 'react-bootstrap';
import { Lens } from '@icons';
import { translate } from '@components/translation/translation';
import { debounce } from '@mui/material';

const QuickSearchbarByArray = ({
	width,
	allProjects,
	allNotices,
	allBeneficiaries,
	projects,
	setProjects,
	setNotices,
	setBeneficiaries,
	aggregateTypeChoice,
	placeholderText,
	isSubstep,
	prevIsSubstep,
	selectedEntity,
	isSearchReset,
	setIsSearchReset,
}) => {
	const [searchValue, setSearchValue] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (isSearchReset) {
			setSearchValue('');
			setIsSearchReset(false);
		}
	}, [isSearchReset, setIsSearchReset]);

	const debouncedSetSearchTermRef = useRef(
		debounce(
			(
				value,
				currentType,
				isSubstepCurrent,
				selectedEntityCurrent,
				projectsCurrent,
				allNoticesCurrent,
				allBeneficiariesCurrent,
				allProjectsCurrent,
			) => {
				value = value.trim().toLowerCase();

				if (currentType === 'cup') {
					let filtered = allProjectsCurrent;

					if (value) {
						filtered = filtered.filter(
							(project) => project.name.toLowerCase().includes(value) || (project.cup && project.cup.toLowerCase().includes(value)),
						);

						setProjects(filtered);
					} else {
						setProjects(allProjectsCurrent);
					}
				} else if (currentType === 'notice' || currentType === 'company') {
					if (!isSubstepCurrent) {
						if (currentType === 'notice') {
							let filtered = allNoticesCurrent;

							if (value) {
								filtered = filtered.filter(
									(notice) =>
										notice.noticeCall.toLowerCase().includes(value) ||
										(notice.noticeName && notice.noticeName.toLowerCase().includes(value)),
								);

								setNotices(filtered);
							} else {
								setNotices(allNoticesCurrent);
							}
						} else if (currentType === 'company') {
							let filtered = allBeneficiariesCurrent;

							if (value) {
								filtered = filtered.filter(
									(beneficiary) =>
										beneficiary.companyName.toLowerCase().includes(value) ||
										(beneficiary.companyCode && beneficiary.companyCode.toLowerCase().includes(value)),
								);

								setBeneficiaries(filtered);
							} else {
								setBeneficiaries(allBeneficiariesCurrent);
							}
						}
					} else {
						let filtered = projectsCurrent;

						if (value) {
							filtered = filtered.filter(
								(project) => project.name.toLowerCase().includes(value) || (project.code && project.code.toLowerCase().includes(value)),
							);
						} else {
							if (currentType === 'notice' && selectedEntityCurrent) {
								filtered = allProjectsCurrent.filter((project) => project.notice && project.notice.id === selectedEntityCurrent);
							} else if (currentType === 'company' && selectedEntityCurrent) {
								filtered = allProjectsCurrent.filter((project) => project.company && project.company.id === selectedEntityCurrent);
							}
						}

						setProjects(filtered);
					}
				}

				setIsLoading(false);
			},
			500,
		),
	);

	useEffect(() => {
		if (allNotices.length === 0 && aggregateTypeChoice === 'notice' && !isSubstep) return;
		if (allBeneficiaries.length === 0 && aggregateTypeChoice === 'company' && !isSubstep) return;
		
		setIsLoading(true);

		debouncedSetSearchTermRef.current(
			searchValue,
			aggregateTypeChoice,
			isSubstep,
			selectedEntity,
			projects,
			allNotices,
			allBeneficiaries,
			allProjects,
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchValue, isSubstep, prevIsSubstep, allNotices, allBeneficiaries, allProjects, aggregateTypeChoice]);

	return (
		<InputGroup className="search-table align-items-center mt-md-0 ms-1" style={{ width: width || '300px' }}>
			<FormControl
				type="text"
				className="filter-text-box"
				placeholder={placeholderText ? placeholderText : translate('common.search', 'Cerca') + '...'}
				aria-label={placeholderText ? placeholderText : translate('common.search', 'Cerca') + '...'}
				value={searchValue}
				onChange={(e) => setSearchValue(e.target.value)}
			/>
			<div style={{ width: '40px', textAlign: 'center' }}>
				{isLoading ? (
					<Spinner as="span" className="ms-2" animation="border" size="sm" role="status" aria-hidden="true" />
				) : (
					<Lens className="lens" />
				)}
			</div>
		</InputGroup>
	);
};

export default QuickSearchbarByArray;
